<template>
  <path pid="0" d="M21 4H5a3 3 0 00-3 3v12a3 3 0 003 3h16a3 3 0 003-3V7a3 3 0 00-3-3zM5 6h16a1 1 0 01.89.55L13 12.78 4.11 6.55A1 1 0 015 6zm16 14H5a1 1 0 01-1-1V8.92l8.43 5.9a1 1 0 001.14 0L22 8.92V19a1 1 0 01-1 1z"/>
</template>
